interface ErrorMessageProps {
  message: string | null
  className?: string
  style?: React.CSSProperties
}

const styles: Record<string, React.CSSProperties> = {
  errorMessage: {
    color: '#e74c3c',
    marginBottom: '16px',
    padding: '10px',
    backgroundColor: '#fadbd8',
    borderRadius: '4px',
  },
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, className, style }) => {
  if (!message) return null

  return (
    <div style={{ ...styles.errorMessage, ...style }} className={className}>
      {message}
    </div>
  )
}

export default ErrorMessage
